export default "__VITE_ASSET__3e554329__"